import axios from 'axios'
import router from '@router/index'
import {Loading} from 'element-ui'
import Vue from 'vue'
import store from '../store/index'

const env = require('../../env')
const instance = process.env.NODE_ENV !== 'production' ?
  axios.create({
    timeout: 15000
  }) :
  axios.create({
    timeout: 15000,
    baseURL: env.API_ROOT
  })

// baseURL and proxy doesn't work together,
// you need to use prefix instead.

// const instance = axios.create({
//   // proxy: process.env.NODE_ENV !== 'production' ? true : false,
//   timeout: 10000,
//   // baseURL: env.API_ROOT
// })

let loadinginstace
// let hideLoading
// let hideMessage


instance.interceptors.request.use(function (config) {
  // let { method, params, data } = config
  // hideLoading = false
  // hideMessage = false
  // if(method == 'get' && params) {
  //   if(params.hideLoading === true) {
  //     hideLoading = true
  //   }
  //   if(params.hideMessage === true) {
  //     hideMessage = true
  //   }
  // }
  // else {
  //   if(data) {
  //     if(data.hideLoading === true) {
  //       hideLoading = true
  //     }
  //     if(data.hideMessage === true) {
  //       hideMessage = true
  //     }
  //   }
  // }

  // if(!hideLoading) {
  //   // 全局loading
  //   loadinginstace = Loading.service({ fullscreen: true })
  // }

  // loadinginstace = Loading.service({ fullscreen: true })
  // en-US zh-HK
  if(localStorage.getItem('lang')) {
    config.headers['Accept-Language'] = localStorage.getItem('lang')
  }

  if(localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  }
  let {url} = config||{}
  if(url.indexOf('/option')==-1&&url.indexOf('/admin/list/data')==-1)
  {
    config.cancelToken = new axios.CancelToken(c => {
      //强行中断请求要用到的
      store.dispatch('request/addHttpRequestList',c)
    })
  }
  return config
}, function (error) {
  // try {
  //   loadinginstace.close()
  // } catch(e) {

  // }
  return Promise.reject(error)
})

instance.interceptors.response.use(function (res) {
  // try {
  //   loadinginstace.close()
  // } catch(e) {

  // }

  // const { data } = res
  // const { code = '', message = '' } = data
  // if(code && message && code !== 1000 && !hideMessage) {
  //   showMessage({
  //     message: data.message_language || data.message,
  //   })
  //   return Promise.reject(res)
  // }
  return res
}, function (error) {
  // try {
  //   loadinginstace.close()
  // } catch(e) {

  // }
  // // 对响应码做相应处理
  // const response = error.response
  // // console.log(error, response, '====')
  // const { status, data } = response
  // if (error && response && status === 401) {
  //   const { fullPath } = router.history.current
  //   if (fullPath.indexOf('/login') === -1) {
  //     router.push({
  //       path: '/login',
  //       query: {
  //         fullPath
  //       }
  //     })
  //   }
  // } else if (error && response && status === 500) {
  //   showMessage({
  //     message: data.message_language || data.message,
  //   })
  // } else if (error && response && data) {
  //   const { code = '', non_global } = data
  //   if(non_global === 1) {
  //     // 不攔截
  //     return Promise.resolve(response)
  //   }
  //   if(code !== 1000 && !hideMessage) {
  //     showMessage({
  //       message: data.message_language || data.message,
  //     })
  //   }
  // }
  return Promise.reject(error)
})

let messageTime

const showMessage = (options = {}) => {
  const now = Date.now()/1000
  if(!messageTime || now - messageTime > 2) {
    messageTime = now

    Vue.prototype.$MessageBox({
      btnType: 'danger',
      ...options
    })
  }
}

const checkActiveTime = () => {
  const timeNow = Date.now()
  const activeTime = localStorage.getItem('activeTime') || ''

  if(activeTime) {
    // 活躍時間 180 min
    const activeOut = (Number(activeTime) + (Number(env.ACTIVE_TIME || 60*180)*1000)) - timeNow <= 0
    if(activeOut) {
      cleanLogin()
    }
  }
  localStorage.setItem('activeTime', timeNow)
}

const cleanLogin = () => {
  try {
    localStorage.setItem('token', '')
    localStorage.setItem('auth', '')
  } catch {}
}


const Axios = (options = {}) => {

  const { method } = options
  const optionsParams = method == 'get'? options.params: options.data
  let hideLoading = false
  let hideMessage = false
  if(optionsParams && optionsParams.hideLoading) {
    hideLoading = true
    delete optionsParams.hideLoading
  }
  if(optionsParams && optionsParams.hideMessage) {
    hideMessage = true
    delete optionsParams.hideMessage
  }




  return new Promise((resolve, reject) => {
    // 活躍
    checkActiveTime()
    if(!hideLoading) {
      loadinginstace = Loading.service({ fullscreen: true })
    }

    instance({
      ...options
    })
      .then(res => {
        if(!hideLoading && loadinginstace) {
          loadinginstace.close()
        }

        const { data } = res
        const { code = '', message_language, message } = data
        if(code && message && code !== 1000) {
          if(!hideMessage) {
            showMessage({
              message: message_language || message
            })
          }
          reject(res)
        }
        else {
          resolve(res)
        }
      })
      .catch(err => {
        if(!hideLoading && loadinginstace) {
          loadinginstace.close()
        }
        handlerError(resolve, reject, err, options, hideMessage)
      })
  })
}


const handlerRefreshToken = (resolve, reject, refresh_token, options) => {
  instance({
    method: 'post',
    url: '/admin/refresh',
    data: {
      refresh_token
    }
  })
    .then(res => {
      const { data } = res
      localStorage.setItem('token', data.access_token)
      const refreshToken = data.refresh_token
      if(refreshToken) {
        localStorage.setItem('refresh_token', refreshToken)
      }
      Axios(options)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
    .catch(err => {
      const { fullPath } = router.history.current
      if (fullPath.indexOf('/login') === -1) {
        store.dispatch('filter/setOpenFilterCar',null)
        router.push({
          path: '/login',
          query: {
            fullPath
          }
        })
      }
    })
}

const handlerError = (resolve, reject, err, options, hideMessage) => {
  const response = err.response
  const { status, data } = response
  if(hideMessage){
    reject(err)
    return
  }
  if(data.type == 'application/json'){
    const reader = new FileReader()
    reader.readAsText(data)
    reader.onload = () => {
      const { message, message_language } = JSON.parse(reader.result)
      showMessage({
        message: message_language || message,
      })
    }
    return
  }
  console.log('code---',data,status,response)
  if(err && response && status === 401) {

    const refreshToken = localStorage.getItem('refresh_token')
    const token = localStorage.getItem('token')
    if(refreshToken && token) {
      handlerRefreshToken(resolve, reject, refreshToken, options)
      return
    }
    const { fullPath } = router.history.current
    if (fullPath.indexOf('/login') === -1) {
      store.dispatch('filter/setOpenFilterCar',null)
      router.push({
        path: '/login',
        query: {
          fullPath
        }
      })
    }
  }
  else if(err && response && status === 500) {
    console.log('code---500',data)
    console.log('code---500',data.code)
    if(data.code === 5000){
      showMessage({
        width:500,
        red:true,
        isCenter:true,
        title: '<span class="flex-align-center flex-center"><i class="el-icon-error color-danger mg-r-3"></i><span>Server Error</span></span>',
        message:'<span  class="flex-center"><i class="el-icon-s-comment mg-r-3"></i><span>Please contact the technical team for support!</span></span>',
      })
    }else 
      showMessage({
        message: data.message_language || data.message,
      })
  }
  // else if(err && response && status === 403) {
  //   const { code = '', non_global } = data
  //   if(code==6006||code==4000){
  //     const { fullPath } = router.history.current
  //     if (fullPath.indexOf('/login') === -1) {
  //       router.push({
  //         path: '/login',
  //         query: {
  //           fullPath
  //         }
  //       })
  //     }
  //   }
  // }
  else if(err && response && data) {
    const { code = '', non_global } = data
    if(non_global === 1) {
      resolve(response)
      return
    }
    if(code == 4533 || code == 4534){
      reject(err)
      return
    }
    if(code !== 1000 && !hideMessage) {
      showMessage({
        message: data.message_language || data.message,
      },data)
      // console.log('errScroll',errScroll)
      // errScroll.setScrollData(data)
      // setTimeout(function () {
      //   errScroll.methods.setScrollData(data)
      let errData = {}
      let {field} = data||{}
      if(field)
      {
        errData[field] = data.message_language
        store.dispatch('errorfield/setErrorData',errData)
      }

      // },200)
    }
  }

  reject(err)
}

export default Axios
